import { Button } from "../../../components/buttons/button";
import { ProfileIcon } from "../../../components/cards/profilePic";
import { Icon } from "../../../components/icon/icon";
import { SettingsLayout } from "../../../components/layout/settingsLayout";
import { ProfileModalRoot } from "../../../components/modal/app_modals/profileModalRoot";
import { Pill } from "../../../components/pill";
import { PageHeader } from "../../../components/typography/pageHeader";
import { BgWrapper } from "../../../components/wrapper/bgWrapper";
import { useModalControl } from "../../../customeHooks/useModalControl";
import { useAppSelector } from "../../../redux/hooks";

export const ProfilePage = () => {
  const { activeModal, modal, modalOpen, handleModalOpen, handleModalClose } =
    useModalControl();
  const { adminProfile: stateProfile } = useAppSelector((state) => state.auth);

  return (
    <div className="w-full">
      <PageHeader header={"Settings"} className="font-fraunces font-normal" />
      <main className="mt-10 flex flex-col items-start gap-[30px] md:flex-row md:gap-[80px]">
        <SettingsLayout />
        <main className="flex w-full flex-col gap-8">
          <div className="flex w-full flex-col gap-[2px]">
            <div className="flex h-[58px] cursor-pointer items-center justify-between rounded-2xl bg-white p-3">
              <h1 className="font-fustat text-base font-bold text-grey-950">
                Profile
              </h1>
            </div>
            <BgWrapper className="flex items-center gap-2.5 rounded-t-2xl">
              <ProfileIcon dimension={47} className={"!p-2"} img={undefined} />
              <div className="flex flex-col">
                <p className="text-base font-bold text-primary">
                  {stateProfile?.firstName} {stateProfile?.lastName}
                </p>
                <p className="text-sm text-grey-500">{stateProfile?.email}</p>
              </div>
            </BgWrapper>
          </div>
          <div className="flex w-full flex-col gap-[2px]">
            <div className="flex h-[58px] cursor-pointer items-center justify-between rounded-2xl bg-white p-3">
              <h1 className="font-fustat text-base font-bold text-grey-950">
                Security
              </h1>
            </div>
            <BgWrapper className="flex items-center justify-between gap-2.5 rounded-t-2xl">
              <div className="flex items-center gap-2.5">
                <Icon
                  svg={"smartphone"}
                  width={20}
                  height={20}
                  className={"mb-1"}
                />
                <div className="flex flex-col">
                  <p className="text-base font-bold text-primary">
                    Two-Factor Authentication{" "}
                  </p>
                  <p className="text-sm text-grey-500">Authenticator app</p>
                </div>
              </div>
              <Pill text={"ENABLED"} variation={"green"} />
            </BgWrapper>
            <div
              onClick={() => {
                handleModalOpen("enterVerificationCode");
              }}
              className="flex h-[58px] cursor-pointer items-center justify-between rounded-2xl bg-white pr-3"
            >
              <Button
                text="Generate new backup codes"
                icon="key-round"
                type="button"
                variation="blue"
                iconClassName={"mb-1"}
                className="max-w-fit"
              />
              <Icon
                svg={"chevron-right"}
                width={20}
                height={20}
                className={"mb-1"}
              />
            </div>
          </div>
        </main>
      </main>

      <ProfileModalRoot
        activeModal={activeModal}
        modal={modal}
        modalOpen={modalOpen}
        handleModalClose={handleModalClose}
        handleModalOpen={handleModalOpen}
      />
    </div>
  );
};
